var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('v-layout',{attrs:{"wrap":"","justify-end":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('enterprise-filter')],1)],1),_c('h1',[_vm._v(_vm._s(_vm.enterpriseName))]),_c('br'),_c('status-table'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }